import { type ReactNode } from "react";

import { useChatEventHandlers } from "./hooks/useChatEventHandlers";

interface ChatEventHandlersProviderProps {
  children: ReactNode;
}

/**
 * Mounts the Sendbird event handlers that keep React Query caches
 * up-to-date with real-time channel changes. This replaces the
 * former ChatStateProvider (constate) which combined data fetching
 * with event handler registration.
 */
export function ChatEventHandlersProvider(props: ChatEventHandlersProviderProps) {
  const { children } = props;

  useChatEventHandlers();

  return <>{children}</>;
}
